/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Barcos_Meta_DescriptionInputs */

const es_barcos_meta_description = /** @type {(inputs: Barcos_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace náutico de Zarpar: salidas compartidas, alquiler con o sin patrón y barcos en Lista 6ª. Filtra por puerto, fechas y precio.`)
};

const gl_barcos_meta_description = /** @type {(inputs: Barcos_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace náutico de Zarpar: saídas compartidas, alugueiro con ou sen patrón e barcos en Lista 6ª. Filtra por porto, datas e prezo.`)
};

const en_barcos_meta_description = /** @type {(inputs: Barcos_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar marketplace: shared trips, rentals with or without skipper, and List 6 boats. Filter by port, dates and price.`)
};

/**
* | output |
* | --- |
* | "Zarpar marketplace: shared trips, rentals with or without skipper, and List 6 boats. Filter by port, dates and price." |
*
* @param {Barcos_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const barcos_meta_description = /** @type {((inputs?: Barcos_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Barcos_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_barcos_meta_description(inputs)
	if (locale === "en") return en_barcos_meta_description(inputs)
	return es_barcos_meta_description(inputs)
});